/* Local helpers for the Funds views. Keeps fund-specific derivations out of the
   shared selectors barrel (which we don't edit). Re-exports shared lookups so the
   page files import from a single place. */
import type { Dataset, ID, Property } from '@/types/entities'

export { accountById, trackById, latest } from '@/lib/selectors'

/** Properties assigned to a fund (by fundId). */
export const propertiesForFund = (d: Dataset, fundId: ID): Property[] =>
  d.properties.filter((p) => p.fundId === fundId)

/** Latest revenue snapshot value for a property (monthly run-rate), or 0. */
export const latestRevenue = (p: Property): number => {
  const snaps = p.revenue
  if (!snaps || !snaps.length) return 0
  return [...snaps].sort((a, b) => (a.date < b.date ? 1 : -1))[0].value
}

/** Latest occupancy snapshot value for a property, or undefined. */
export const latestOccupancy = (p: Property): number | undefined => {
  const snaps = p.occupancyPct
  if (!snaps || !snaps.length) return undefined
  return [...snaps].sort((a, b) => (a.date < b.date ? 1 : -1))[0].value
}
